import React, { useEffect, useState } from "react";
import { inject, observer } from "mobx-react";

import Progress from "../Progress";

const PacksTaskAction = ({
  packs,
  onComplete,
  //
  assistantStore,
  chatHelpersStore,
  component
}) => {
  const [progress, setProgress] = useState({label: "Preparing pack"})

  const handleComplete = async (...params) => {
    typeof onComplete === "function" && (await onComplete(...params));
  };

  const updatePackIcon = async (pack) => {
    // get pack Icon here
    const res = await chatHelpersStore.getIcon({ packName: pack.name });

    if (!res) return pack;

    const updateRes = await assistantStore.savePack({
      id: pack.id,
      name: pack.name,
      color: res.iconColor,
      icon: res.iconName,
      createDefaultSheet: 0,
    });

    return { ...updateRes?.data, id: pack.id, isNew: pack.isNew };
  };

  const handleOnLoad = async () => {
    try {
      await assistantStore.fetchAndLoadPacks();

      const packsRes = (
        await Promise.allSettled(
          packs.map((pack) => chatHelpersStore.getOrCreatePack(pack))
        )
      )
        .filter((item) => item.reason !== "rejected" && item.value)
        .map((item) => item.value);

      const res = (
        await Promise.allSettled(
          packsRes.map((packRes) => {
            if (packRes.isNew)
              return updatePackIcon({ ...packRes.pack, isNew: packRes.isNew });
            return Promise.resolve(packRes.pack);
          })
        )
      )
        .filter((item) => item.reason !== "rejected" && item.value)
        .map((item) => item.value);

      await handleComplete(res);
    } catch (e) {
      console.log(`e->`, e);
    }
  };

  const renderPacksTaskAction = () => {
    return (
      <Progress progress={progress} parentComponent={component} />
    );
  };

  useEffect(() => {
    handleOnLoad();
  }, []);

  return renderPacksTaskAction();
};

export default inject(({ store }) => {
  return {
    assistantStore: store.assistantStore,
    chatHelpersStore: store.chatHelpersStore,
  };
})(observer(PacksTaskAction));
